import { AppState } from "@store";
import { FetchingState } from "rd-redux-http";
import { CampaignSpentBudget } from "@common";

export function campaignSpentBudgetSelector(
    appState: AppState,
    campaignId: string
): CampaignSpentBudget & { isLoading: boolean } {
    const fetchState = FetchingState.compose([
        appState.campaignList.campaigns.fetchState,
        (appState.campaignList.campaignSpentBudget[campaignId] || { fetchState: FetchingState.INITIAL }).fetchState
    ]);

    if (fetchState === FetchingState.INITIAL || fetchState === FetchingState.FETCHING) {
        return {
            campaignId,
            budget: 0,
            budgetUSD: 0,
            currency: "",
            spentPart: 0,
            budgetSpentCampaignCurrency: 0,
            budgetSpentUSD: 0,
            isLoading: fetchState === FetchingState.INITIAL ? false : true
        };
    }

    return {
        isLoading: false,
        ...FetchingState.getDataOrDefault(appState.campaignList.campaignSpentBudget[campaignId], {
            campaignId,
            budget: 0,
            budgetUSD: 0,
            currency: "",
            spentPart: 0,
            budgetSpentCampaignCurrency: 0,
            budgetSpentUSD: 0
        })
    };
}
